import i18n from '@/i18n';
import { StoreProvider } from '@/services/StoreProvider';

export function length (v, params) {
  const l = v?.length | 0;

  if (typeof params.max === 'string') {
    params.max = replaceVariable(params.max);
  }

  return (l >= params.min && l <= params.max) || i18n.global.t('validation.length', { ...params });
}

export function size (v, params) {
  if (params.max) {
    if ((v?.length || 0) >= params.max) return i18n.global.t('validation.size', { ...params });
  }
  return true;
}

export function min (v, params) {
  const numeric = parseFloat(v);
  return numeric >= params || i18n.global.t('validation.min', { min: params });
}

export function max (v, params) {
  const numeric = parseFloat(v);
  return numeric <= params || i18n.global.t('validation.max', { max: params });
}

export function noSpace (v) {
  return (v && !v.includes(' ')) || i18n.global.t('validation.no-space');
}

export function required (v) {
  return (v !== undefined && v !== null && v !== '') || i18n.global.t('validation.required');
}

export function numberRule (v, float) {
  if (float) {
    if (isNaN(parseFloat(v)) || !isFinite(v)) {
      return i18n.global.t('validation.number');
    }
  } else {
    if (isNaN(parseInt(v)) || !isFinite(v) || !Number.isInteger(Number(v))) {
      return i18n.global.t('validation.integer');
    }
  }
  return true;
}

function replaceVariable (key) {
  const limits = StoreProvider.limits;
  return limits[key];
}
